import React from "react";
import "./styles.css";

/**
 * @function PhoneWrapper
 * @returns {React.Component}
 * @exported true
 * @description This is the faux phone show in the MainView page. It shows the content through an iframe.
 */
export default function PhoneWrapper(props) {
  return (
    <div className="content-container flex-width all-center">
      <div className="flex-container flex-horizontal main-view-container">
        <div className="phone-wrapper flex-container all-center">
            <div className="iframe-wrapper">
             {props.children}
            </div>
        </div>
      </div>
    </div>

  );
}